import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import WaitlistContent from './WaitlistContent.jsx';

const Waitlist = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [product, setProduct] = useState({});
  const [color, setColor] = useState('');
  const [disclaimer, setDisclaimer] = useState('');

  document.removeEventListener('click', handleClick);
  document.addEventListener('click', handleClick);

  function handleClick(evt) {
    if (evt.target.closest('[data-waitlist-open="true"]')) {
      const variantSelector = evt.target.closest('[data-waitlist-open="true"]');
      const container = variantSelector.closest('[data-section-type="product"]');
      const product = container.querySelector('[data-product-json]')
        ? container.querySelector('[data-product-json]')
        : container.parentElement.closest('[data-section-type="product"]').querySelector('[data-product-json]');
      const productJson = JSON.parse(product.innerHTML);
      const variantColor = container
        .querySelector('.ProductOption__variant-custom--color.ProductOption__variant--selected')
        .getAttribute('data-value');

      let disclaimerMsg = `
        Yes! I want to be notified when this item is back in stock and would like to receive Windsor\'s newsletter with special offers and fashion trends delivered daily to my inbox. I understand I can unsubscribe at any time. *See our 
        <a href='https://www.windsorstore.com/pages/contest-terms-conditions'>Terms and Conditions</a> and 
        <a href='https://www.windsorstore.com/pages/privacy-policy'>Privacy Policy</a> for more details. Windsor, Inc., 9603 John St., Santa Fe Springs, CA 90670, (888) 494-6376*
      `;

      setProduct(productJson);
      setColor(variantColor);
      setModalIsOpen(true);
      setDisclaimer(disclaimerMsg);
    }
  }

  const closeModal = () => {
    // console.log('clicked');
    setModalIsOpen(false);
  };

  return (
    <div className="WaitlistModal__wrapper">
      {modalIsOpen && (
        <div className="WaitlistModal__container">
          <div className="WaitlistModal__overlay" onClick={closeModal}></div>
          <WaitlistContent
            color={color}
            product={product}
            disclaimer={disclaimer}
            close={closeModal}
            isInternational={window.HTMLEmbedElement.country_iso !== 'US'}
          />
        </div>
      )}
    </div>
  );
};

Waitlist.defaultProps = {
  items: [],
};

const renderWaitlistModal = (el) => {
  // get product json by closest element clicked
  ReactDOM.render(<Waitlist />, el);
};

export default () => {
  const el = document.querySelector('[data-waitlist-modal]');
  if (el) {
    renderWaitlistModal(el);
  }
};
